import React from "react"
import {
    Document,
    Page,
    Text,
    View,
    Link,
    StyleSheet,
    pdf
} from "@react-pdf/renderer"

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: "Helvetica"
    },
    title: {
        fontSize: 16,
        fontFamily: "Helvetica-Bold",
        marginBottom: 4
    },
    subtitle: {
        fontSize: 11,
        marginBottom: 12,
        color: "#444"
    },
    row: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#ddd",
        paddingVertical: 6
    },
    headerRow: {
        flexDirection: "row",
        backgroundColor: "#eee",
        paddingVertical: 6,
        fontFamily: "Helvetica-Bold"
    },
    rollCol: {
        width: "12%",
        paddingHorizontal: 4
    },
    nameCol: {
        width: "28%",
        paddingHorizontal: 4
    },
    linkCol: {
        width: "60%",
        paddingHorizontal: 4
    },
    link: {
        color: "#1a0dab",
        textDecoration: "underline"
    },
    footer: {
        position: "absolute",
        bottom: 15,
        left: 30,
        right: 30,
        fontSize: 8,
        color: "#888",
        textAlign: "right"
    }
})

function LinksDocument({ title, linkHeader, rows, className, examName }) {
    return (
        <Document title={title}>
            <Page size="A4" style={styles.page}>
                <Text style={styles.title}>{title}</Text>
                <Text style={styles.subtitle}>
                    {[className, examName].filter(Boolean).join("  |  ")}
                </Text>
                <View style={styles.headerRow} fixed>
                    <Text style={styles.rollCol}>Roll No</Text>
                    <Text style={styles.nameCol}>Name</Text>
                    <Text style={styles.linkCol}>{linkHeader}</Text>
                </View>
                {rows.map((row, index) => (
                    <View style={styles.row} key={index} wrap={false}>
                        <Text style={styles.rollCol}>{row.rollNo}</Text>
                        <Text style={styles.nameCol}>{row.name}</Text>
                        <Link style={[styles.linkCol, styles.link]} src={row.link}>
                            {row.link}
                        </Link>
                    </View>
                ))}
                <Text
                    style={styles.footer}
                    fixed
                    render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                />
            </Page>
        </Document>
    )
}

/**
 * Builds a "Roll No | Name | clickable link" PDF in the browser and triggers a download.
 * rows: [{ rollNo, name, link }]
 */
export async function downloadLinksPdf({
    title = "Student Download Links",
    linkHeader = "Download Link",
    rows,
    className,
    examName,
    fileName = "student_links.pdf"
}) {
    const blob = await pdf(
        <LinksDocument
            title={title}
            linkHeader={linkHeader}
            rows={rows}
            className={className}
            examName={examName}
        />
    ).toBlob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
}
